import { useEffect } from 'react'

function Logout (props) {
  // NOTE - wrap function in useEffect otherwise we get error
  // Cannot update a component (`App`) while rendering a different component
  useEffect(() => {
    props.handleLogout()
    // Full page load so in-memory state and third-party scripts (e.g. GTM) are discarded
    window.location.replace('/login')
  }, [])

  return null
}

export default Logout
